var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-card", { staticClass: "ik-chart-card" }, [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "ik-chart-card-title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _c("p", { staticClass: "table_title_img" }),
        _c("span", { staticClass: "logo" }),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "ik-chart-card-chart",
        style: "height: " + _vm.height + "",
        attrs: { id: _vm.code },
      },
      [
        _c("span", { staticClass: "ik-label-main-value" }, [
          _vm._v(_vm._s(_vm.mainValue)),
        ]),
        _c("span", { staticClass: "ik-label-main-unit" }, [
          _vm._v(_vm._s(_vm.mainUnit)),
        ]),
        _c(
          "table",
          { staticClass: "ik-label-secondary" },
          _vm._l(_vm.labelData, function (item) {
            return _c(
              "tr",
              { key: item.id, staticClass: "ik-label-secondary-tr" },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "ik-label-secondary-td ik-label-secondary-firstAnalysis",
                  },
                  [_c("span", [_vm._v(_vm._s(item.firstAnalysis))])]
                ),
                _c(
                  "td",
                  {
                    staticClass:
                      "ik-label-secondary-td ik-label-secondary-secondAnalysis",
                  },
                  [_c("span", [_vm._v(_vm._s(item.secondAnalysis))])]
                ),
                _c(
                  "td",
                  {
                    staticClass:
                      "ik-label-secondary-td ik-label-secondary-value",
                  },
                  [_c("span", [_vm._v(_vm._s(item.value))])]
                ),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }